import Auth from 'shared/amplifyAuth'
import { Dispatch } from 'redux'
import { groupAccessMappingInterface } from '../interfaces/IReduxState'

export const getGroups = async (dispatch?: Dispatch) => {
  if (process.env.REACT_APP_E2E_AUTH_MODE === 'local') {
    const groups = ['superuser']
    if (dispatch) dispatch({ type: 'SET_USER_GROUPS', payload: groups })
    return groups
  }

  try {
    const currentSession = await Auth.currentSession()
    const groups =
      currentSession.getIdToken().decodePayload()['cognito:groups'] || []
    if (dispatch) dispatch({ type: 'SET_USER_GROUPS', payload: groups })
    return groups
  } catch (e) {
    return false
  }
}

export const isUserSuperuser = (userGroups: string[]) => {
  return userGroups.some(
    (groupName: string) => groupName.toLowerCase() === 'superuser'
  )
}

export const isUserKarlina = (userGroups: string[]) => {
  return userGroups.some(
    (groupName: string) => groupName.toLowerCase() === 'karlina'
  )
}

export const isUserFactory = (userGroups: string[]) => {
  return userGroups.some(
    (groupName: string) =>
      groupName.toLowerCase() === 'pabrik' ||
      groupName.toLowerCase() === 'pabrikot'
  )
}

export const isUserAdmin = (userGroups: string[]) => {
  return userGroups.some(
    (groupName: string) => groupName.toLowerCase() === 'admin'
  )
}

export const checkAccess = (
  userGroups: string[],
  groupAccessMapping: groupAccessMappingInterface,
  service: string,
  action: string
) => {
  if (isUserSuperuser(userGroups)) {
    return true
  }

  return Boolean(
    userGroups.find((groupName) => {
      const lowerGroupName = groupName.toLowerCase()
      if (!(lowerGroupName in groupAccessMapping)) {
        return false
      }
      return groupAccessMapping[lowerGroupName].find(
        (access: { service: string; action: string }) =>
          access.service === service && access.action === action
      )
    })
  )
}

export const getCurrentUser = async (dispatch?: Dispatch) => {
  if (process.env.REACT_APP_E2E_AUTH_MODE === 'local') {
    const currentUser = {
      id: 'e2e-local-user',
      username: 'e2e-local-user',
      attributes: { name: 'E2E Local User' },
    }
    if (dispatch) dispatch({ type: 'SET_CURRENT_USER', payload: currentUser })
    return currentUser
  }

  try {
    const currentUser = await Auth.currentUserInfo()
    if (dispatch) dispatch({ type: 'SET_CURRENT_USER', payload: currentUser })
    return currentUser
  } catch (e) {
    return false
  }
}
